<template>
  <div class="home">
    <v-row
      class="mx-0 my-0"
    >
      <v-col
        class="mx-0 my-0"
        cols="12"
        xs="5"
      >
        <v-card
          class="mx-auto my-1"
          max-width="374"
        >
          <template>
            <v-img
              class="white--text align-end"
              height="250"
              position="center top"
              gradient="to bottom, rgba(255,255,255,0), rgba(0,0,0,0.5)"
              src="../assets/title.jpg"
            >
              <v-card-title>소면공방 파트너 센터 로그인</v-card-title>
            </v-img>
            <v-row>
              <v-col
                md="10"
                offset-md="1"
              >
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="pa-2"
                >
                  <v-text-field
                    v-model="email"
                    label="이메일"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="비밀번호"
                    counter
                    @click:append="show1 = !show1"
                    @keypress.enter="singInEmail"
                  ></v-text-field>

                  <v-checkbox
                    v-model="checkbox"
                    label="아이디 저장"
                    @change="setID"
                  ></v-checkbox>

                  <v-alert
                    type="error"
                    dense
                    outlined
                  >
                    로그인 후 사업자 등록증을 등록해주세요.
                  </v-alert>

                  <v-row>
                    <v-col
                      cols="8"
                    >
                      <v-btn
                        :disabled="!valid"
                        color="success"
                        @click="singInEmail"
                      >
                        LogIn
                      </v-btn>

                      <v-btn
                        class="ml-2"
                        color="primary"
                        @click="goSignup"
                      >
                        회원가입
                      </v-btn>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col
                    cols="2"
                    >
                      <v-btn
                        :disabled="!valid"
                        color="red"
                        dark
                        small
                        fab
                        @click="signInWithGoogle"
                      >
                        <v-icon>mdi-google</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      show1: false,
      checkbox: false,
      email: '',
      password: '',
      loading: false
    }
  },

  created () {
    this.getID()
  },

  methods: {
    validate () {
      this.$refs.form.validate()
    },

    async signInWithGoogle () {
      const provider = new this.$firebase.auth.GoogleAuthProvider()
      this.$firebase.auth().language = 'ko'
      this.loading = true
      try {
        const r = await this.$firebase.auth().signInWithPopup(provider)
        this.$store.commit('setFireUser', r.user)
        this.$router.replace('Products')
      } finally {
        this.loading = false
      }
    },

    singInEmail () {
      var _this = this

      _this.$firebase.auth().setPersistence('session').then(
        function () {
          // console.log('세션 유지 하기')
          _this.$firebase.auth().signInWithEmailAndPassword(_this.email, _this.password).then(
            function () {
              _this.$router.replace('Products')
            },
            function (error) {
              alert(error.message)
            }
          )
        }
      ).catch(function (error) {
        alert(error.message)
      })
    },

    setID () {
      if (this.checkbox) {
        console.log('아이디 저장')
        this.$cookies.set('id', this.email, '1d')
      } else {
        console.log('아이디 저장 취소')
        this.$cookies.remove('id')
      }
    },

    getID () {
      if (this.$cookies.isKey('id')) {
        this.email = this.$cookies.get('id')

        if (this.email) {
          this.checkbox = true
        }
      }
    },

    signOut () {
      this.$firebase.auth().signOut()
    },

    goSignup () {
      this.$router.replace('signup')
    }
  }
}
</script>
